/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Dialogue_Event_Group_HelpInputs */

const en_ccsl_export_dialogue_event_group_help = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Dialogue List will normally contain shot changes and shot change descriptions in the Notes field.`)
};

const fr_ccsl_export_dialogue_event_group_help = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La liste des dialogues contient generalement les changements de plan et leurs descriptions dans le champ Notes.`)
};

const de_ccsl_export_dialogue_event_group_help = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Dialogliste enthält normalerweise Einstellungenwechsel und Beschreibungen der Einstellungenwechsel im Notizfeld.`)
};

const it_ccsl_export_dialogue_event_group_help = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'elenco dei dialoghi conterrà normalmente i cambi di inquadratura e le relative descrizioni nel campo Note.`)
};

const ru_ccsl_export_dialogue_event_group_help = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В поле «Примечания» список диалогов обычно содержит информацию о смене кадров и описание этой смены.`)
};

const es_ccsl_export_dialogue_event_group_help = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La lista de diálogo normalmente contendrá cambios de toma y descripciones de cambios de toma en el campo Notas.`)
};

const zh_cn2_ccsl_export_dialogue_event_group_help = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对话列表通常会在“备注”字段中包含镜头切换和镜头切换说明。`)
};

const ja_ccsl_export_dialogue_event_group_help = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常、ダイアログ リストには、ショットの変更と、ショットの変更の説明が [メモ] フィールドに含まれます。`)
};

const hi_ccsl_export_dialogue_event_group_help = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद सूची में सामान्यतः शॉट परिवर्तन और शॉट परिवर्तन विवरण नोट्स फ़ील्ड में शामिल होंगे।`)
};

const pt_pt2_ccsl_export_dialogue_event_group_help = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A lista de diálogos normalmente conterá mudanças de plano e descrições dessas mudanças no campo "Notas".`)
};

/**
* | output |
* | --- |
* | "The Dialogue List will normally contain shot changes and shot change descriptions in the Notes field." |
*
* @param {Ccsl_Export_Dialogue_Event_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_dialogue_event_group_help = /** @type {((inputs?: Ccsl_Export_Dialogue_Event_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Dialogue_Event_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_dialogue_event_group_help(inputs)
	if (locale === "de") return de_ccsl_export_dialogue_event_group_help(inputs)
	if (locale === "it") return it_ccsl_export_dialogue_event_group_help(inputs)
	if (locale === "ru") return ru_ccsl_export_dialogue_event_group_help(inputs)
	if (locale === "es") return es_ccsl_export_dialogue_event_group_help(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_dialogue_event_group_help(inputs)
	if (locale === "ja") return ja_ccsl_export_dialogue_event_group_help(inputs)
	if (locale === "hi") return hi_ccsl_export_dialogue_event_group_help(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_dialogue_event_group_help(inputs)
	return en_ccsl_export_dialogue_event_group_help(inputs)
});